// extracted by mini-css-extract-plugin
export default {"skipModal":"SkipModal_skipModal__eCZ1x","header":"SkipModal_header__KVsqX","buttons":"SkipModal_buttons__LjY6F","close":"SkipModal_close__wmiw0"};